import React from 'react'
import classNames from 'classnames'
import { isEmpty, get } from 'lodash-es'

import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core/styles'

import { IContestEntry, IContest } from 'protos'

import Point from 'components/Point'
import GeneralListItem from 'components/GeneralListItem'

import EventRankingItemAvatar from './EventRankingItemAvatar'
import EventRankingItemDetails from './EventRankingItemDetails'
import EventRankingItemSubtitle from './EventRankingItemSubtitle'

import ownEntryBackground from './assets/own_entry_bg.png'

interface Props {
  entry?: IContestEntry
  contest?: IContest | null
  onClick?: (userId: string) => void
  isOwnEntry?: boolean
  onClickAvatar?: (userId: string) => void
  isDropdownActive?: boolean
}

const styles = (theme: Theme) => createStyles({
  ownEntry: {
    paddingTop: theme.spacing() * 4,
    paddingBottom: theme.spacing() * 4,
    backgroundSize: 'cover',
    backgroundImage: `url(${ownEntryBackground})`,
    backgroundPosition: 'center',
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const EventRankingItem: React.SFC<InjectedProps> = ({
  entry,
  classes,
  contest,
  onClick,
  isOwnEntry,
  onClickAvatar,
  isDropdownActive,
}) => {
  if (!entry) {
    return null
  }

  const isMarked = get(contest, 'ownEntry.user.userId', 'a') === get(entry, 'user.userId', 'b')
  const isDisabled = !isOwnEntry && !(onClick && entry.user && entry.user.userId)
  const hasDetails = !isOwnEntry && !isEmpty(entry.details)
  const _onClick = !isDisabled && hasDetails ? () => { onClick!(entry.user!.userId!) } : undefined

  return (
    <GeneralListItem
      className={classNames({ [classes.ownEntry]: isOwnEntry })}
      disabled={isDisabled}
      headline={entry.user && entry.user.name}
      subtitle={<EventRankingItemSubtitle rank={entry.rank} prize={entry.prize} rankDelta={entry.rankDelta} />}
      leftChild={<EventRankingItemAvatar onClick={onClickAvatar} user={entry.user} rank={entry.rank} />}
      rightChild={<Point value={entry.score} />}
      dropdownChild={hasDetails && <EventRankingItemDetails details={entry.details} />}
      isDropdownActive={isDropdownActive}
      onClick={_onClick}
      isMarked={isMarked}
    />
  )
}

export default withStyles(styles)(EventRankingItem)
